import React from 'react';
import PropTypes from 'prop-types';

const LogoRight = ({ size, fill, altFill }) => (
  <svg viewBox="0 0 245.25 133.91" width={size}>
    <path
      fill={altFill}
      d="M323.32,100.29h-3.6a2.61,2.61,0,0,0-2.57,2.92v48.87c0,1.41,1,2.56,3.63,2.56h1.48c2.65,0,3.62-1.15,3.62-2.56V103.21A2.61,2.61,0,0,0,323.32,100.29Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={altFill}
      d="M263.51,113.37c-5.6.07-8.8,2.12-10.89,5.26V103.21a2.61,2.61,0,0,0-2.56-2.92h-3.6a2.61,2.61,0,0,0-2.56,2.92v48.87c0,1.41,1,2.56,3.62,2.56H249c2.65,0,3.62-1.15,3.62-2.56V125.56c.91-1.35,3.68-4.83,7.89-4.33,5.21.62,6.36,3.36,6.36,6.19v24.66c0,1.41,1,2.56,3.62,2.56H272c2.65,0,3.62-1.15,3.62-2.56V124.5C275.6,121.94,274.91,113.9,263.51,113.37Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={altFill}
      d="M281,139.31V128.79a15.33,15.33,0,0,1,15.33-15.33h0a15.33,15.33,0,0,1,15.33,15.33h0v10.52h0a15.34,15.34,0,0,1-15.33,15.33h0A15.34,15.34,0,0,1,281,139.31Zm8.48-10.52v10.52a6.85,6.85,0,0,0,6.85,6.84h0a6.84,6.84,0,0,0,6.84-6.84h0V128.79a6.85,6.85,0,0,0-6.84-6.85h0a6.87,6.87,0,0,0-6.85,6.85Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={altFill}
      d="M352.89,116.17c-3.13-3.3-5.25-3.07-7-2.18a33.77,33.77,0,0,0-5.15,4.07v-1.6a2.61,2.61,0,0,0-2.57-2.91h-3.6a2.61,2.61,0,0,0-2.56,2.91v35.62c0,1.41,1,2.56,3.62,2.56h1.48c2.66,0,3.63-1.15,3.63-2.56V125.23c3.92-4.06,5.91-4.22,7.15-3.88s2.53,1.83,3.36.71S354,117.46,352.89,116.17Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={fill}
      d="M139.49,75.87s-5.44-4.17-10.15-2.9l.73,1.27s-10,2-12.51,10.33l2.9-.54s-4.53,10.15-11.6,9.78c.54,2.9,4.35,6,4.35,6s-4,5.07-.55,13.77c-2.71,4.53-3.8,7.8-3.44,14.87s-.73,10.33-1.27,11.24a5.65,5.65,0,0,0,2-.55,8.83,8.83,0,0,1-1.27,4.53,24.26,24.26,0,0,0,8.33-1.27c-.18,4.36,1.82,10.7,7.44,13.78.54,2,1.08,5.62.54,6.71,3.08.72,3.44-.18,3.44-.18A34.68,34.68,0,0,1,131,173a7.41,7.41,0,0,0,3.08-2.18,62.49,62.49,0,0,1,.19,7.07c6-3.44,6.88-5.62,7.79-7.25.91,4.17,2.17,11.24,12.14,14.5,6,5.62,11.24,7.44,12.69,9.25l.55-1.81s7.43-4.53,11.06-8.16l-.19,1.81s10.52-5.62,11.24-16.49c0,0,3.45,6.16,8.7,6.88a32.39,32.39,0,0,1,.73-5.8s2.17,3.09,2.54,3.63c0-4.9,2.54-11.78,2.54-11.78a11.82,11.82,0,0,0,1.63,3.26c-.19-4,3.8-9.24,5.07-12.69l-.72,2.9s6.16-7.25,5.07-14.5c1.81,1.63,6.17,1.45,9.07-.73-1.27-1.26-2.72-2.71-3.09-3.8a26.38,26.38,0,0,0,2.36,1.81,66.9,66.9,0,0,1,.18-10.51c.55-6.71-.9-13.06-6.71-17.4,2.9-1.82,3.81-6.17,1.46-10.88,1.63.54,3.08-1.63,4.16-3.81-1.81-.9-4.53-2.17-11.6-7.25s-11.24-6.34-14.5-6.71c-2.54-4-5.62-4.53-7.07-5.25a4.64,4.64,0,0,1,4.71,0s-1.63-8.34-14-10.15c.54-.73,3.44-1.82,3.44-1.82s-11.6-4-15.95,4.54c-1.81-1.64-1.63-5.8,3.62-6.71-6.88-4-19.93-3.63-22.29,4.35-1.63-1.09-1.81-3.63-1.81-3.63S138.59,69.71,139.49,75.87Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={altFill}
      d="M149.26,87.47s-17.58,3.08-3.08-17.22c.18,2.54,6,13.59,8.88,15,0,0-6.53-.72-9.24-5.62C145.82,79.67,144.73,83.66,149.26,87.47Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={altFill}
      d="M160.32,84.93a14,14,0,0,1-10-9.61c-2.54-8.15,8.52-12.14,13.41-11C156.69,64.27,148.9,73.69,160.32,84.93Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={altFill}
      d="M187.51,89.64s2,.91,6.52,7.07,6.17,9.25,10.34,10l-.91-1.27a19.14,19.14,0,0,0,5.8,1.64c-1.63-1.09-2.72-2.54-5.07-6.71s-3.45-6.89-10.88-9.61a3.77,3.77,0,0,1,2,2.9S191.68,90,187.51,89.64Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={altFill}
      d="M183,87.65s9.24-2.54,20.3,6,13.41,13.6,13.41,13.6,2.9-6.35-8.7-13c4.17,1.81,8,4.89,10.15,2.53-6.34-2.35-16.13-10-23.74-11.78S183,87.65,183,87.65Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={altFill}
      d="M177.9,85.11s6.53-4.17,13.6-2.9c-8.34-4.71-18.31-2.54-19.76,3.27,5.07-4,9.79-3.63,9.79-3.63A34.3,34.3,0,0,0,177.9,85.11Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={altFill}
      d="M163.94,85.84s3.45-9.61-1.81-17.59c-2.54.37-4,5.81-1.45,11.42S163.94,85.84,163.94,85.84Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={altFill}
      d="M168.11,85.84s-2.17-15.23,7.61-19.94a19.84,19.84,0,0,0-2.9,6.52c3.63-4.17,11.79-3.44,16.68,1.27C178.26,71.16,171.74,77.68,168.11,85.84Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={altFill}
      d="M138.93,79l-1.27,4.53s-1.63-2.36-6-1.09a1.43,1.43,0,0,1,.72,1.45s-4.53-.9-6.16,2.54a7.68,7.68,0,0,1,3.8,0s-4.16,2-4.53,4.9a12,12,0,0,1-.36-8.7,14.87,14.87,0,0,0-2.36-.37,18.91,18.91,0,0,1,9.79-4.35V76.77A19.37,19.37,0,0,1,138.93,79Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={altFill}
      d="M144.27,89.46A47.8,47.8,0,0,0,137,97.71c-3.35,4.71-4.35,8.25-8.7,8.61a14.16,14.16,0,0,1,.82-1.54c-3.54,2.36-4.71,2.36-5.89,2.45,3.71-2.54,4.59-9.22,9.33-12.87a23.6,23.6,0,0,1,6.35-3.63s-2.27,1.72-2.27,3.08A26.61,26.61,0,0,1,144.27,89.46Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={altFill}
      d="M122.29,93.32s.23,1.45-3.85,5.21-3.4,6.57-3,9.38a13.44,13.44,0,0,1,4.8-6.44c3-2.31,3.85-4,3.67-5.89a6.83,6.83,0,0,1-2.35,2.58S123,95.31,122.29,93.32Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={altFill}
      d="M120.75,93.18a9,9,0,0,1-6.25,2.9C116,98,118.81,98.12,120.75,93.18Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={altFill}
      d="M125.2,110s-7.8,3.49-9.52,10.24c-1.72,6.44-1,10.65-3.22,13.15.73-1.95.5-4.54.59-9.79S115.09,112.21,125.2,110Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={altFill}
      d="M135.26,109.9s-9.84.72-14.91,8.34c-3.9,5.85-1.23,10.38-6.94,21.39,3.13.5,6.39-4.67,6.85-5.66-.37,6.34.72,13.23,2.71,17.22,0,0-.18-7.16.64-10.15a51.27,51.27,0,0,0,2.27,10.51c1.72,4.89,2,6.16,1.81,8.25a8.2,8.2,0,0,0,1.9-4.72s2,3.54,2.81,12.6c2-2,2.54-8.88,2.54-8.88a19.39,19.39,0,0,1,.72,9.15c1.18-.18,1.27-1,1.27-1a13.36,13.36,0,0,1-.54,5.43c3.53-4.62,6.71-6.61,5.8-15.49s-3.54-12.15-2.36-19.49a14.62,14.62,0,0,0-2.35,4.08,22.77,22.77,0,0,1,0-11.51c-2.45,1.81-4.26,6.43-4.26,6.43a17.7,17.7,0,0,1,1.27-9.6c-2.63,1.26-5.17,5.07-5.44,7.07-.64-3.72,1-10.16,3.9-13.15-2.09.64-4.63,3-5.35,3.81.27-2,3.26-6.34,4.44-7.16a16.35,16.35,0,0,0-8.25,4.8C124.52,119.46,129.14,112.66,135.26,109.9Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={altFill}
      d="M145.18,148.29s2.54,2,2.27,9.51.45,8,.45,8a11.46,11.46,0,0,1,2.45-3.63c-1.82,3.45-1.82,14.32,1.18,19.13-3.9-3-6.35-10.06-6.17-15.59S145.72,151.82,145.18,148.29Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={altFill}
      d="M207,110s7.79,3.49,9.51,10.24c1.73,6.44,1,10.65,3.22,13.15-.72-1.95-.49-4.54-.59-9.79S217.14,112.21,207,110Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={altFill}
      d="M197,109.9s9.83.72,14.91,8.34c3.89,5.85,1.22,10.38,6.93,21.39-3.12.5-6.39-4.67-6.84-5.66.36,6.34-.73,13.23-2.72,17.22,0,0,.18-7.16-.64-10.15a51.65,51.65,0,0,1-2.26,10.51c-1.72,4.89-2,6.16-1.81,8.25a8.17,8.17,0,0,1-1.91-4.72s-2,3.54-2.81,12.6c-2-2-2.54-8.88-2.54-8.88a19.39,19.39,0,0,0-.72,9.15c-1.18-.18-1.27-1-1.27-1a13.46,13.46,0,0,0,.55,5.43c-3.54-4.62-6.71-6.61-5.81-15.49s3.54-12.15,2.36-19.49a14.74,14.74,0,0,1,2.36,4.08,22.77,22.77,0,0,0,0-11.51c2.44,1.81,4.26,6.43,4.26,6.43a17.82,17.82,0,0,0-1.27-9.6c2.63,1.26,5.17,5.07,5.44,7.07.63-3.72-1-10.16-3.9-13.15,2.08.64,4.62,3,5.35,3.81-.28-2-3.27-6.34-4.44-7.16a16.32,16.32,0,0,1,8.24,4.8C207.72,119.46,203.1,112.66,197,109.9Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={altFill}
      d="M187.05,148.29s-2.53,2-2.26,9.51-.46,8-.46,8a11.37,11.37,0,0,0-2.44-3.63c1.81,3.45,1.81,14.32-1.18,19.13,3.9-3,6.34-10.06,6.16-15.59S186.51,151.82,187.05,148.29Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={altFill}
      d="M154.06,172.39a18.52,18.52,0,0,0,5.55,11.33c-.61-2.1-.68-5,.41-6.52-.07,3.6,1.77,9.38,3.47,11.35-3.6-3.26-8.16-7.27-9.31-9.65S154.06,172.39,154.06,172.39Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={altFill}
      d="M168.52,188.69a44.19,44.19,0,0,0,2.92-6.26,19.83,19.83,0,0,0,.89-5s.81,2,.4,6.12a18.73,18.73,0,0,0,5.31-11c.74,2.92.47,6.66-1.5,8.9S172,185.7,168.52,188.69Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={altFill}
      d="M148.14,107a3.57,3.57,0,0,0,2.4,2.77c1.41.45,3.36-.28,3.76-1.45a4.14,4.14,0,0,0-1.67-.23,1.29,1.29,0,0,1-1.36.54A1.36,1.36,0,0,1,150,107,11,11,0,0,0,148.14,107ZM181,108.63a1.28,1.28,0,0,1-1.36-.54,4.2,4.2,0,0,0-1.68.23c.41,1.17,2.36,1.9,3.76,1.45a3.55,3.55,0,0,0,2.4-2.77,10.82,10.82,0,0,0-1.85,0A1.37,1.37,0,0,1,181,108.63ZM191.28,112c-3.47-3.2-4.49-3.67-5.51-2.45s-2.79,1.63-4.89,1.56-3.94-.4-3.67-.13c.74.61,1.42,4.08,1.22,4.83,1.84-.34,2.65,0,3.13.74a8,8,0,0,0-4.15,1.43c-.2.14-.61-.07-.61-1.43s-.34-4.48-2-5.16c.07.54-.34,1.08-.62.81s.07-1.42-1.76-2.78-3.16-2.25-3.6-3.37-.21-2.34.54-2.28c.64.45,2.45,3.33,5.74,3.61s6.87-2.55,9-3.64,4.93-1.26,6.26.31c-1.09.91-2.48,2-2.48,2.27s0,.85,1.42.85a3.26,3.26,0,0,0,3.33-1.63c.92-1.46.75-3.77-1.83-6.39s-4.72-4.69-8.5-8.36-7.1-4.72-10.47-3.64c-2.84.92-4.11,2.93-5.78,3.1-1.68-.17-3-2.18-5.79-3.1-3.36-1.08-6.69,0-10.47,3.64s-5.91,5.74-8.5,8.36-2.75,4.93-1.83,6.39a3.27,3.27,0,0,0,3.33,1.63c1.43,0,1.43-.41,1.43-.85s-1.39-1.36-2.48-2.27c1.32-1.57,4.08-1.4,6.25-.31s5.75,3.91,9,3.64,5.1-3.16,5.75-3.61c.74-.06,1,1.16.54,2.28s-1.77,2-3.6,3.37-1.5,2.51-1.77,2.78-.68-.27-.61-.81c-1.63.68-2,3.8-2,5.16s-.41,1.57-.62,1.43a7.91,7.91,0,0,0-4.14-1.43c.47-.74,1.29-1.08,3.13-.74-.21-.75.47-4.22,1.22-4.83.27-.27-1.56.07-3.67.13s-3.88-.33-4.9-1.56-2-.75-5.5,2.45-3.81,6.86-2.45,8.77a32.49,32.49,0,0,0,4.22,4.35,5,5,0,0,1,.4-3.4c.89-1.9,1.23-2.72.89-3.47s-.48-2.44.34-3.06c2.17,3.47,3.06,3.67,5,4.22-3.47,2-3.54,4.48-3.54,4.48a58.74,58.74,0,0,1,6.8,2c-2.86,0-6.73-.47-6.73-.47s0,2.58.48,3,3.33,1.29,9.1,3.19c-3.12-.06-8.76-.27-8.76-.27a4.77,4.77,0,0,0,.88,1.09c.68.68,3.81,1,9.52,2.38-1.91,1.29-5.92.75-8.36.75,5.71,6.93,13.73,2.44,14.81.54s1-4.21-2-5.71-6.93-3-7.2-4.21a9.92,9.92,0,0,1,.27-3.4s.95,2.44,3,1.63,2.45-2.58,4.9-2a26.85,26.85,0,0,0,7.22,0c2.45-.54,2.85,1.22,4.89,2s3-1.63,3-1.63a9.83,9.83,0,0,1,.28,3.4c-.28,1.22-4.22,2.71-7.21,4.21s-3.13,3.81-2,5.71,9.11,6.39,14.82-.54c-2.45,0-6.46.54-8.36-.75,5.71-1.36,8.84-1.7,9.51-2.38a4.69,4.69,0,0,0,.89-1.09s-5.64.21-8.77.27c5.78-1.9,8.63-2.78,9.11-3.19s.48-3,.48-3-3.88.47-6.73.47a58.26,58.26,0,0,1,6.79-2s-.06-2.51-3.53-4.48c2-.55,2.85-.75,5-4.22.82.62.68,2.31.34,3.06s0,1.57.88,3.47a5,5,0,0,1,.41,3.4,32.67,32.67,0,0,0,4.21-4.35C195.08,118.87,194.74,115.2,191.28,112ZM174,100.79c.32-.5,3.14-3.62,6.52-4.17,2.54-.4,3.31,1.36,2.77,1.27-4.49-.41-8.84,3.31-8.84,3.31C174.21,101.29,173.76,101.25,174,100.79Zm-16.2.41s-4.35-3.72-8.83-3.31c-.55.09.22-1.67,2.76-1.27,3.39.55,6.21,3.67,6.53,4.17S158,101.29,157.79,101.2Zm5.53,9.74c0-.81.74-1.34,1.62-1.61a3.28,3.28,0,0,1,2.76.14,1.69,1.69,0,0,1,1.21,1.47A27,27,0,0,0,163.32,110.94Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={altFill}
      d="M159.05,125.33a4.69,4.69,0,0,1,2.78.21,11.84,11.84,0,0,0,4.36,1.19v-1.84a8.45,8.45,0,0,1-2.72-.44C161.76,124,160.2,124,159.05,125.33Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={altFill}
      d="M173.19,125.33a4.72,4.72,0,0,0-2.79.21,11.79,11.79,0,0,1-4.35,1.19v-1.84a8.48,8.48,0,0,0,2.72-.44C170.48,124,172,124,173.19,125.33Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={altFill}
      d="M160.9,139.49a3,3,0,0,0,.41,3.13,3.64,3.64,0,0,1,.54-1.5s2.45-.08,5.71,0v-1.86A28,28,0,0,0,160.9,139.49Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={altFill}
      d="M171.33,139.49a3,3,0,0,1-.41,3.13,3.48,3.48,0,0,0-.54-1.5s-2.45-.08-5.71,0v-1.86A28,28,0,0,1,171.33,139.49Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={altFill}
      d="M154.34,140.54s2.22-.09,2.58.36a15.65,15.65,0,0,0,1.45,5.62C156.2,146.2,153.39,142.39,154.34,140.54Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={altFill}
      d="M177.9,140.54s-2.22-.09-2.59.36a15.24,15.24,0,0,1-1.45,5.62C176,146.2,178.85,142.39,177.9,140.54Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={altFill}
      d="M160,155.24a5.32,5.32,0,0,1-2.38,1.22c-1.15.14-1.9-1.15-1.56-5.84A16.77,16.77,0,0,0,160,155.24Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={altFill}
      d="M172.26,155.24a5.39,5.39,0,0,0,2.38,1.22c1.16.14,1.9-1.15,1.56-5.84A16.43,16.43,0,0,1,172.26,155.24Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={altFill}
      d="M160.72,155.07a11.4,11.4,0,0,0,1.56-.1c0-.82-.3-1.29-.94-1.23S160.72,154.8,160.72,155.07Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={altFill}
      d="M169.92,155.07a11.4,11.4,0,0,0,1.56-.1c0-.82-.3-1.29-.94-1.23S169.92,154.8,169.92,155.07Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={altFill}
      d="M163,154.94h1.09s.15-.92-.51-.92S162.93,154.56,163,154.94Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={altFill}
      d="M164.53,154.94h1.08s.14-.88-.51-.92S164.49,154.56,164.53,154.94Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={altFill}
      d="M166.76,154.94h1.09s.14-.92-.51-.92S166.73,154.56,166.76,154.94Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={altFill}
      d="M168.32,154.94h1.09s.14-.88-.51-.92S168.29,154.56,168.32,154.94Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={altFill}
      d="M154.11,159s-.23,1.63,1.95,1.77,3.44-.86,5.89-2a8.3,8.3,0,0,1,6.62-.73c2.54.68,6.39,3.18,8.38,2.77s1.31-1.68,1.31-1.68.5-.45.69.36a12.39,12.39,0,0,1-1,6.85,8.13,8.13,0,0,1-5.12,4,2.29,2.29,0,0,0-.45-1.18,9.49,9.49,0,0,1-6,3.26,8.28,8.28,0,0,1-6.34-3.35c-.5.18-.46,1-.41,1.13-1.41.37-4.53-1.13-5.76-4.66a11.74,11.74,0,0,1-.45-6.53C153.66,158.3,154.11,158.39,154.11,159Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={fill}
      d="M185.33,109.11l11.7,0a2.25,2.25,0,0,1,2.33,2.51c1.54.09,2.73.15,1.21,3.48-1,2.11-2.12,1.93-3.31,2.17-4.16,8.35-6.75,12.52-11.65,12.62C176.71,115.4,185.33,109.11,185.33,109.11Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={fill}
      d="M144.56,129.59c-3.95.17-7.48-6.62-10.05-12.56-2.15-.23-2.91-1.19-3.48-3.13-.69-2.34.25-2.91,1.71-2.8-.47-1.41.57-1.91,1.48-1.88s10.94,0,10.94,0h3.34c1,0,1.53,1,2.58,1s2.81-1,3.75-1h1.34c2.91,0,3.75.43,5.5,1.68s2.83,2.42,4.66,2.34c1.67-.09,4.09-3.92,6.5-3.92h4.67l7.08,20.92a43.67,43.67,0,0,0-5.41.25c-4,.33-8,0-9.59-3.09s-1.83-8.91-3.16-9.33-1.59,1.33-2.25,3.83-2.75,8.25-8.75,8.17-10.5-.58-10.5-.58l-.36.1"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={altFill}
      d="M135.52,110.23s20.29,0,22.87.16,3.84,1.39,5.24,2.37a4.09,4.09,0,0,0,3.38.78l.37,3.32a2.77,2.77,0,0,0-3.89,2.29c-.64,3.55-1.85,10.39-6.92,10.89-6.56.66-12.09,0-13.47-.83-2.39-1.33-4-4.94-7.43-12.36-2.24-.72-2.9-1-3.44-3.13s.41-1.91,1.7-1.86C133.69,110.81,134.11,110.18,135.52,110.23Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={fill}
      d="M134.11,114s-.58-1.11.08-1.19.94.63,1.31,1.83S134.72,115.71,134.11,114Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={altFill}
      d="M196.79,110.54s-20.17-.18-22.75-.1-3.93,1.34-5.38,2.31a5.17,5.17,0,0,1-3.83.75l-.17,3.39s3.25-1.31,3.75,2.25,1.29,10.42,6.32,11c6.49.77,12,.13,13.42-.63,2.44-1.3,4.27-4.91,8.07-12.31,2.26-.7,2.94-1,3.6-3.11s-.28-1.92-1.56-1.88C198.56,111.15,198.19,110.51,196.79,110.54Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={fill}
      d="M198,114.29s.65-1.11,0-1.19-1,.62-1.42,1.82S197.23,116.06,198,114.29Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={fill}
      d="M141,112.35s10.81,0,14.84.5,5.63,1,6,4.26-.23,9.3-1.65,10.49-4,1.74-12.36,1.1c-4.58-.41-5-1.7-6.28-4.31s-3.07-7.83-3.39-8.79S137.93,112.58,141,112.35Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={fill}
      d="M192,112.17s-10.7,0-14.69.5-5.58,1-5.94,4.22.23,9.2,1.63,10.38,4,1.72,12.25,1.09c4.53-.41,5-1.68,6.21-4.26s3.59-7.73,3.91-8.69S195.09,112.4,192,112.17Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={altFill}
      d="M159.13,113s-6.84-.54-10-.67c-8.5-.33-10.5,4.84-9.34,8.17a48.32,48.32,0,0,0,3,7s-5.33-9-5.66-13.67c.16-2,2.16-2.66,6.16-2.5s10.5.34,10.5.34Z"
      transform="translate(-107.95 -60.51)"
    />
    <path
      fill={altFill}
      d="M185.13,112s-1,.17-4.5.33-9.67,5-9.17,9.84c-.17,1.16-2-4.67-2-6.34s3.08-3.68,6.21-3.84S185.13,112,185.13,112Z"
      transform="translate(-107.95 -60.51)"
    />
    <polygon fill={altFill} points="40.84 52.49 43.17 52.49 34.01 61.66 40.84 52.49" />
    <polygon fill={altFill} points="46.34 53.16 49.34 53.32 36.01 65.32 46.34 53.16" />
    <polygon fill={altFill} points="73.84 53.16 66.68 62.99 76.51 53.16 73.84 53.16" />
    <polygon fill={altFill} points="80.01 53.16 68.34 67.32 83.01 53.16 80.01 53.16" />
  </svg>
);

LogoRight.propTypes = {
  fill: PropTypes.string.isRequired,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  altFill: PropTypes.string,
};

LogoRight.defaultProps = {
  altFill: 'white',
};

export default LogoRight;
